import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import Seo, { Breadcrumbs } from "@/components/Seo";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/faq").then((r) => setItems(r.data));
  }, []);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": items.map((it) => ({
      "@type": "Question",
      "name": it.q,
      "acceptedAnswer": { "@type": "Answer", "text": it.a },
    })),
  };

  return (
    <div className="container-bl py-10 max-w-3xl" data-testid="page-faq">
      <Seo
        title="FAQ · Vehicle Rentals in Oxnard | B&L Rentals"
        description="Frequently asked questions about renting vehicles in Oxnard: insurance, cancellations, pickup, and EV rentals."
        canonical={typeof window !== "undefined" ? window.location.origin + "/faq" : undefined}
        schema={items.length > 0 ? schema : undefined}
      />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "FAQ" }]} />
      <div className="text-sm uppercase tracking-widest text-[#E2AB20] font-semibold">FAQ</div>
      <h1 className="mt-2 text-4xl font-heading font-bold text-white">Common questions</h1>
      <p className="mt-3 text-[#AEB9C9]">Everything about our Oxnard rental process, insurance, and cancellations.</p>

      <div className="mt-10">
        <Accordion type="single" collapsible className="w-full">
          {items.map((it, i) => (
            <AccordionItem value={`item-${i}`} key={i} data-testid={`faq-${i}`}>
              <AccordionTrigger className="text-left font-heading font-semibold text-white">{it.q}</AccordionTrigger>
              <AccordionContent className="text-[#AEB9C9] leading-relaxed">{it.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
